import i18next from "i18next";
import intervalPlural from "i18next-intervalplural-postprocessor";
import { initReactI18next } from "react-i18next";
import de from "@/translations/de.json";
import hr from "@/translations/hr.json";
import { getLocaleCookie } from "@/utils/cookies";

export const defaultNS = "translation";
export const resources = {
  de: { translation: de, ...de },
  hr: { translation: hr, ...hr },
} as const;

const i18n = i18next.createInstance();

i18n.use(intervalPlural).use(initReactI18next);

i18n.init({
  returnNull: false,
  debug: false,
  fallbackLng: "hr",
  lng: getLocaleCookie() ?? "hr",
  initAsync: false,
  interpolation: {
    escapeValue: false,
  },
  resources: resources,
  defaultNS,
});

declare module "i18next" {
  interface CustomTypeOptions {
    defaultNS: typeof defaultNS;
    resources: (typeof resources)["hr"]["translation"];
  }
}

export default i18n;
